module.exports = __webpack_public_path__ + "static/@KoramangalaSocial-f89d00a536125be8001ee58be3b13158.webp";